import { LeftSectionTableTranslations } from "./types";

export const enTranslations: LeftSectionTableTranslations = {
    disease: "Disease",
    students: "Students",
    patients: "Patients",
    diagnosis: "Diagnosis",
    avg_score: "Avg Score",
    noRecordAvailable: "No Record Available"
};